import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { environment } from '../../../../environments/environment';
import { InboxService } from '../inbox/inbox.service';

export enum NOTIFICATIONTYPE {
  INBOX = 1
}

@Injectable({
  providedIn: 'root',
})
export class FirebaseMessagingService {
  
  private platformId = inject(PLATFORM_ID);
  private messaging = inject(Messaging);
  private inboxService = inject(InboxService);

  broadcast = new BroadcastChannel('pushChannel');

  initializeFirebaseMessaging() {
    if (!isPlatformBrowser(this.platformId)) return;

    getToken(this.messaging, { vapidKey: environment.firebaseConfig.vpaidKey})
    .then((token) => {
      if (token) {
        localStorage.setItem('FCM_TOKEN', token);
      }
    })
    .catch((error) => {
      console.error('Error getting FCM token:', error);
    });

    onMessage(this.messaging, {
      next: (payload: any) => {
        const payload_formatted = JSON.parse(payload.data.payload);
        // this.sound.play();
        if (payload_formatted.msg_type == NOTIFICATIONTYPE.INBOX) {
          this.inboxService.getMessageConversation(payload_formatted);
        }
      },
      error: (error) => console.log('Message error', error),
      complete: () => console.log('Done listening to messages'),
    });

    this.broadcast.onmessage = (event) => {
      // this.sound.play();
      const payload = JSON.parse(event.data.data.payload);
      if (payload.msg_type === NOTIFICATIONTYPE.INBOX) {
        this.inboxService.getMessageConversation(payload);
      }
    };
  }
}
